import { message } from "antd";
import { FormControlLabel, Switch } from "@mui/material";
import React, { useEffect, useState } from "react";
import DyanmicFrom from "../../../DyanmicForm/DyanmicFrom";
import CustomSubmit from "./CustomSubmit";

const CardForm = ({
  cardData,
  setCardData,
  preview,
  oldData,
  attributes,
  error,
  page_id,
  children,
  updateComponentData,
  setError,
  customValidate,
  reinitOnIdChangeOnly,
}) => {

  const [active, setActive] = useState(false);

  const handleChange = (event) => {
    setActive(event.target.checked);
  };

  useEffect(() => {
    setActive(preview);
  }, [preview]);

  useEffect(() => {
    if (oldData) setCardData(oldData);
  }, [reinitOnIdChangeOnly ? oldData?.id : oldData]);

  const isValidUrl = (value) => {
    try {
      new URL(value);
      return true;
    } catch {
      return false;
    }
  };
  const validateFields = () => {
  let errors = [];
  let urlValidationErrors = [];

  attributes.forEach((item) => {
    const value = cardData?.[item.key];
    const isEmpty =
      value === undefined ||
      value === null ||
      value === "" ||
      (Array.isArray(value) && value.length === 0);

    if (item.required && isEmpty) {
      errors.push(item.key);
    }

    if (item.conditionalRequired) {
      const parentValue = cardData?.[item.conditionalRequired];
      const hasParent =
        parentValue !== undefined &&
        parentValue !== null &&
        parentValue !== "" &&
        !(Array.isArray(parentValue) && parentValue.length === 0);

      if (hasParent && isEmpty) {
        errors.push(item.key);
      }
    }

    if (
      (item?.inputType === "url" || item?.key?.toLowerCase().includes("url")) &&
      !isEmpty &&
      !isValidUrl(value)
    ) {
      urlValidationErrors.push(item.key); 
    }
  });

  return { errors, urlValidationErrors };
}; 
  return (
    <div className="card">
      <div
        style={{
          display: "flex",
          alignItems: "flex-end",
          justifyContent: "flex-end",
        }}
      >
        {" "}
        <FormControlLabel
          control={<Switch checked={active} onChange={handleChange} />}
          label="Preview"
        />
      </div>
      {active && children}
      {!active && (
        <div className="card-body">
          <div className="row">
            <DyanmicFrom
              level={1}
              error={error}
              attributes={attributes || []}
              data={cardData}
              setData={(e) => {
                setCardData(e);
              }}
            />
          </div>
          {page_id && <CustomSubmit data1={cardData} data2={oldData} handleSubmit={() => {
            const { errors, urlValidationErrors } = validateFields();
            if (urlValidationErrors.length > 0) {
              if (setError) setError([...errors, ...urlValidationErrors]);
              return;
            }

            if (errors.length > 0) {
              if (setError) setError(errors);
              return;
            }

            if (customValidate) {
              const validationResult = customValidate(cardData);
              if (validationResult) {
                if (setError) setError(validationResult.keys);
                message.error(validationResult.message);
                return;
              }
            }

            updateComponentData(cardData)
          }
          } />
          }

        </div>
      )
      }
    </div >
  );
};

export default CardForm;
